// extracted by mini-css-extract-plugin
export var bottomBlock = "screen1-module--bottom-block--5d8ca";
export var bottomBlockImg = "screen1-module--bottom-block-img--d3407";
export var col = "screen1-module--col--aca03";
export var desc = "screen1-module--desc--4cf21";
export var mainDesc = "screen1-module--main-desc--ec26f";
export var row = "screen1-module--row--208a9";
export var screen1 = "screen1-module--screen1--3e9ab";